<script module> 
               
    export const appState = $state({
        items: []
    });

    export const appProfileState = $state({
        memberDetails: null,
        isUserSubscriber: false,
        dependentDetails: null,
        showDependentEditor: false,
        workingDependent: null,
        bankAccounts: null,
        showBankAccountEditor: false,
        workingBankAccount: null,
        //sideMenuItems:[],
        //selectedSideMenuItem: "",
        //achDetails: null,
        //relationshipTypes: [],
        //genderTypes: [],
        //sexAtBirthTypes: [],
        contactMethods: [],
        documentDeliveryMethods: [],
        canAccessEnrollment: false,
        securityEmail: null,
        securityEmailVerified: false,
        securityEnrolledMfa:[]
    });		

    export const weeCareEnrollmentState = $state({
        hospitals: null,
        relationshipTypes: null,
        phoneNumberTypes: null,
        subscribersNameOrPehpIdNumber: null
    });

    export const appClinicalPoliciesState = $state({
        clinicalPolicies: null,		
        signedAgreement: false
    });

    export const claimsHistoryState = $state({
        memberOptions: [],
        claimTypeOptions: [],
        beginningDate: null,
        endingDate: null,
        memberId: null,
        claimType: null,
        claimsList: [],
        hasAppeals: false,
    });
     
    export const individualInvoicesState = $state({
        beginningDate: null,
        endingDate: null,
        invoicesList: [],
    });
     
</script>


